import { ViewChangelog, ViewCustomer } from '@xeetr/types/models'

import { useCustomerChangelogs } from './customers/useCustomerChangelogs'
import { useCustomerSearch } from './customers/useCustomerSearch'


interface UseCustomersReturn {
  search: ViewCustomer[]
  searchLoading: boolean
  filter: (query: string) => void
  total: number
  page: number
  limit: number
  setPage: (page: number) => void
  setLimit: (limit: number) => void

  changelogs: ViewChangelog[]
  changelogsLoading: boolean
  changelogsSuccess: boolean
  loadChangelogs: (bookingId: string) => void
}

export const useCustomers = (): UseCustomersReturn => {
  const search = useCustomerSearch()
  const changelogs = useCustomerChangelogs()

  return {
    ...search,
    ...changelogs,
  }
}
